import { cva, VariantProps } from "class-variance-authority";

import { MarkerPin01Icon } from "../atoms/icons/MarkerPin01Icon";

const avatarVariants = cva(
  "flex items-center justify-center overflow-hidden rounded-full border border-gray-100 dark:border-gray-900",
  {
    variants: {
      size: {
        default: "size-5 text-xs",
        big: "size-6 text-base",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

type AvatarVariantProps = VariantProps<typeof avatarVariants>;

interface FacilityAvatarProps extends AvatarVariantProps {
  facility: {
    name: string;
    picture?: string;
  };
  showLocationIcon?: boolean;
}

export const FacilityAvatar = ({
  facility,
  size = "default",
  showLocationIcon = false,
}: FacilityAvatarProps) => {
  const initial = facility.name[0];

  return (
    <div className="flex flex-row items-center gap-2">
      <div className={avatarVariants({ size })}>
        {showLocationIcon ? (
          <MarkerPin01Icon className="size-6" pathClassName="stoke-gray-500" />
        ) : facility.picture ? (
          <img
            src={facility.picture}
            alt="avatar"
            className="size-full object-cover"
          />
        ) : (
          <div className="flex size-full items-center justify-center font-semibold text-gray-500">
            {initial}
          </div>
        )}
      </div>
      <div className="flex flex-col justify-center">
        <div className="dark:text-gray-0 line-clamp-1 text-sm font-semibold text-gray-950">
          {facility.name}
        </div>
      </div>
    </div>
  );
};
